import {useState} from 'react';
import Breadcrumb from '../../../common/breadcrumb';
import DailiesSearchFilters from "./dailiesSearchFilters";
import DailiesSearchBody from "./dailiesSearchBody";
import LoadingIndicator from "../../../common/loadingIndicator";
import moment from 'moment';

const DEFAULT_START_DATE = moment().subtract(1, 'month');
const DEFAULT_END_DATE = moment();

/**
 * Dailies Search Component
 * @returns {JSX.Element}
 * @constructor
 */
const DailiesSearch = () => {
    const [tableData, setTableData] = useState([]);
    const [selectedRow, setSelectedRow] = useState({});
    const [filters, setFilters] = useState({
        date_from: DEFAULT_START_DATE.format('YYYY-MM-DD'),
        date_to: DEFAULT_END_DATE.format('YYYY-MM-DD'),
        isLoading: false,
        isSubmitted: false,
        keyword: '',
    });
    const [tableDataDisciplineId, setTableDataDisciplineId] = useState(null);

    return (
        <>
            <Breadcrumb title="Daily Search" parent="Data Entry"/>
            <DailiesSearchFilters
                filters={filters}
                setTableData={setTableData}
                setFilters={setFilters}
                setTableDataDisciplineId={setTableDataDisciplineId}
            />
            <DailiesSearchBody
                filters={filters}
                setFilters={setFilters}
                tableData={tableData}
                setTableData={setTableData}
                selectedRow={selectedRow}
                setSelectedRow={setSelectedRow}
                tableDataDisciplineId={tableDataDisciplineId}
            />
            <LoadingIndicator isLoading={filters.isLoading}/>
        </>
    );
}

export default DailiesSearch;
